import React from "react";
import Timer from "../Timer";
import AuctionDescription from "./AuctionComponents/AuctionDescription";
import AuctionHeading from "./AuctionComponents/AuctionHeading";
import AuctionImage from "./AuctionComponents/AuctionImage";
import AuctionMore from "./AuctionComponents/AuctionMore";
import AuctionOffers from "./AuctionComponents/AuctionOffers";
import AuctionPrice from "./AuctionComponents/AuctionPrice";
const Auction = () => {
    return (
        <>
            <Timer />
            <div className="_nft_wrapper">
                <div className="_nft_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <AuctionImage />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="_nft_content_wrap">
                                    <AuctionHeading />
                                    <AuctionPrice />
                                    <AuctionOffers />
                                </div>
                            </div>
                        </div>
                        <div className="_nft_des_wrap _nft_des_auctcol_wrap">
                            <AuctionDescription />
                        </div>
                    </div>
                </div>
            </div>
            <AuctionMore />
        </>
    )
}
export default Auction;